import * as CONST from 'Reducers/Document/const'

const initState = {
  documentTypeById: {},
  documentTypesList: [],
}

export function document(state = initState, action) {
  switch (action.type) {
    case CONST.GET_DOCUMENT_TYPE_BY_ID_SUCCESS: {
      return {
        ...state,
        documentTypeById: action.payload.documentTypeById,
      }
    }

    case CONST.GET_DOCUMENT_TYPES_SUCCESS: {
      return {
        ...state,
        documentTypesList: action.payload.documentTypesList,
      }
    }

    case CONST.DELETE_DOCUMENT_TYPE_BY_ID_SUCCESS: {
      return {
        ...state,
        documentTypeById: action.payload.documentTypeById,
      }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/Document/reducer.js